import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input } from '@pwc/appkit-react/lib/Input';

import {
  MdArrowForward as AlignRightIcon,
  MdArrowBack as AlignLeftIcon,
  MdImage as ImageIcon,
} from 'react-icons/md';
import { GiMagnifyingGlass } from 'react-icons/all';

const TOOLBAR_ICON_SIZE = '21px';

const ImageToolbar = ({
  showInput,
  src,
  align,
  handleSrcChange,
  handleAlignChange,
  handleResizeIconClick,
}) => {
  const setAlignRight = useCallback(event => {
    event.stopPropagation();
    handleAlignChange('right');
  }, [handleAlignChange]);
  const setAlignLeft = useCallback(event => {
    event.stopPropagation();
    handleAlignChange('left');
  }, [handleAlignChange]);
  const setNoAlign = useCallback(event => {
    event.stopPropagation();
    handleAlignChange(null);
  }, [handleAlignChange]);
  const handleClick = useCallback(event => event.stopPropagation(), []);

  return (
    <div className={classnames('image__toolbarContainer', { 'image__toolbarContainer--withInput': showInput })}>
      {showInput && <Input
        className="image__toolbarInput"
        value={src}
        onChange={handleSrcChange}
        onClick={handleClick}
      />}
      <div className="image__toolbarIconsContainer">
        <div
          className={classnames(
            'image__toolbarIconContainer',
            { 'image__toolbarIconContainer--active': align === 'left' }
          )}
          onClick={setAlignLeft}
        >
          <AlignLeftIcon className="image__toolbarIcon" size={TOOLBAR_ICON_SIZE} />
        </div>
        <div
          className={classnames(
            'image__toolbarIconContainer',
            { 'image__toolbarIconContainer--active': align === null }
          )}
          onClick={setNoAlign}
        >
          <ImageIcon className="image__toolbarIcon" size={TOOLBAR_ICON_SIZE} />
        </div>
        <div
          className={classnames(
            'image__toolbarIconContainer',
            { 'image__toolbarIconContainer--active': align === 'right' }
          )}
          onClick={setAlignRight}
        >
          <AlignRightIcon className="image__toolbarIcon" size={TOOLBAR_ICON_SIZE} />
        </div>
      </div>
      <div
        className={classnames(
          'image__toolbarIconContainer',
          { 'image__toolbarIconContainer--active': align === 'right' }
        )}
        onClick={handleResizeIconClick}
      >
        <GiMagnifyingGlass className="image__toolbarIcon" size={TOOLBAR_ICON_SIZE} />
      </div>
    </div>
  );
};

ImageToolbar.propTypes = {
  showInput: PropTypes.bool,
  src: PropTypes.string,
  align: PropTypes.oneOf(['left', 'right', null]),
  handleSrcChange: PropTypes.func,
  handleAlignChange: PropTypes.func,
  handleResizeIconClick: PropTypes.func,
};

export default ImageToolbar;
